/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */
// import lunr from 'lunr';
// import Vue from 'vue';
import company from '@/services/company';
import * as types from '../mutations/company';

const rebuildCompanyIndex = (state) => {
  delete state.companyListIndex;
  state.companyListIndex = {};
  state.companyList.forEach((item, index) => {
    state.companyListIndex[`_${item.id}`] = index;
  });
};

const rebuildCompanyProfileIndex = (state) => {
  delete state.companyProfileListIndex;
  state.companyProfileListIndex = {};
  state.companyProfileList.forEach((item, index) => {
    state.companyProfileListIndex[`_${item.id}`] = index;
  });
};

const rebuildCompanyAdminIndex = (state) => {
  delete state.companyAdminListIndex;
  state.companyAdminListIndex = {};
  state.companyAdminList.forEach((item, index) => {
    state.companyAdminListIndex[`_${item.id}`] = index;
  });
};

const rebuildAdminIndex = (state) => {
  // rebuild index
  delete state.adminListIndex;
  state.adminListIndex = {};
  state.adminList.forEach((item, index) => {
    state.adminListIndex[`_${item.id}`] = index;
  });
};

const state = {
  companyList: [],
  companyListIndex: {}, // reverse index
  isGettingCompany: false,
  isUploadingCompanyFile: false,
  isSubmittingCompanyInfo: false,
  currentCompanyId: null,
  // profiles
  isGettingCompanyProfile: false,
  companyProfileList: [],
  companyProfileListIndex: {}, // reverse index
  isSubmittingCompanyProfileInfo: false,
  currentCompanyProfileId: null,
  isUploadingCompanyProfileFile: false,
  // company's admins
  isGettingCompanyAdmin: false,
  companyAdminList: [],
  companyAdminListIndex: {}, // reverse index
  isSubmittingcompanyAdminInfo: false,
  currentCompanyAdminId: null,
  // admins
  isSubmittingAdminInfo: false,
  adminList: [],
  adminListIndex: {}, // reverse index
  isGettingAdmin: false,
  // search stuffs
  companyListSearchIndex: null,
  adminListSearchIndex: null,
  // my admin info
  scbAdminInfo: null,
  isGettingAdminMyAdmin: false,
};
const getters = {
  scbAdminInfo(state) {
    return state.scbAdminInfo;
  },
  isAdminInitialLoading(state) {
    return state.isGettingAdminMyAdmin;
  },
  isAdminRole: state => state.scbAdminInfo && state.scbAdminInfo.role === 'ADMIN',
  isViewerRole: state => state.scbAdminInfo && state.scbAdminInfo.role === 'VIEWER',
  adminUserRole(state) {
    return state.scbAdminInfo ? state.scbAdminInfo.role : '';
  },
  companyList(state) {
    return state.companyList;
  },
  companyListIndex(state) {
    return state.companyListIndex;
  },
  currentCompany(state) {
    if (state.currentCompanyId) {
      const indexId = `_${state.currentCompanyId}`;
      if (typeof state.companyListIndex[indexId] !== 'undefined') {
        return state.companyList[state.companyListIndex[indexId]];
      }
    }
    return null;
  },
  companyProfileList(state) {
    return state.companyProfileList;
  },
  companyProfileListIndex(state) {
    return state.companyProfileListIndex;
  },
  currentCompanyProfile(state) {
    if (state.currentCompanyProfileId) {
      const indexId = `_${state.currentCompanyProfileId}`;
      if (typeof state.companyProfileListIndex[indexId] !== 'undefined') {
        return state.companyProfileList[state.companyProfileListIndex[indexId]];
      }
    }
    return null;
  },
  // COMPANY ADMIN USERS
  companyAdminList(state) {
    return state.companyAdminList;
  },
  companyAdminListIndex(state) {
    return state.companyAdminListIndex;
  },
  currentCompanyAdmin(state) {
    if (state.currentCompanyAdminId) {
      const indexId = `_${state.currentCompanyAdminId}`;
      if (typeof state.companyAdminListIndex[indexId] !== 'undefined') {
        return state.companyAdminList[state.companyAdminListIndex[indexId]];
      }
    }
    return null;
  },
  // ADMINS
  adminList(state) {
    return state.adminList;
  },
  adminListIndex(state) {
    return state.adminListIndex;
  },
  /* companyListSearchIndex(state) {
    return state.companyListSearchIndex;
  },
  adminListSearchIndex(state) {
    return state.adminListSearchIndex;
  }, */
};
const actions = {
  COMPANY_CLEAR_STATE({ commit }) {
    return new Promise((resolve) => {
      commit(types.COMPANY_STATE_CLEARED);
      resolve();
    });
  },
  GET_COMPANY_LIST({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.GET_COMPANY_LIST_REQUEST);
      company.getCompany(payload, (err, result) => {
        if (err) {
          commit(types.GET_COMPANY_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_COMPANY_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPLOAD_COMPANY_LOGO({ commit }, file) {
    return new Promise((resolve, reject) => {
      commit(types.UPLOAD_COMPANY_LOGO_REQUEST);
      company.uploadCompanyLogo(file, (err, result) => {
        if (err) {
          commit(types.UPLOAD_COMPANY_LOGO_FAIL);
          return reject(err);
        }
        commit(types.UPLOAD_COMPANY_LOGO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_COMPANY({ commit }, companyId) {
    return new Promise((resolve) => {
      commit(types.CURRENT_COMPANY_SELECTED, companyId);
      resolve();
    });
  },
  CREATE_COMPANY_INFO({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.CREATE_COMPANY_INFO_REQUEST);
      company.createCompanyInfo(payload, (err, result) => {
        if (err) {
          commit(types.CREATE_COMPANY_INFO_FAIL);
          return reject(err);
        }
        commit(types.CREATE_COMPANY_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_COMPANY_INFO({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_COMPANY_INFO_REQUEST);
      company.updateCompanyInfo(payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_COMPANY_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_COMPANY_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_COMPANY_INFO({ commit }, companyId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_COMPANY_INFO_REQUEST);
      company.deleteCompanyInfo(companyId, (err) => {
        if (err) {
          commit(types.DELETE_COMPANY_INFO_FAIL);
          return reject(err);
        }
        commit(types.DELETE_COMPANY_INFO_SUCCESS, companyId);
        return resolve();
      });
    });
  },
  // Profiles
  GET_COMPANY_PROFILE_LIST({ commit }, companyId) {
    return new Promise((resolve, reject) => {
      commit(types.GET_COMPANY_PROFILE_LIST_REQUEST);
      company.getCompanyProfile(companyId, (err, result) => {
        if (err) {
          commit(types.GET_COMPANY_PROFILE_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_COMPANY_PROFILE_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPLOAD_COMPANY_PROFILE_LOGO({ commit }, file) {
    return new Promise((resolve, reject) => {
      commit(types.UPLOAD_COMPANY_PROFILE_LOGO_REQUEST);
      company.uploadCompanyLogo(file, (err, result) => {
        if (err) {
          commit(types.UPLOAD_COMPANY_PROFILE_LOGO_FAIL);
          return reject(err);
        }
        commit(types.UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_COMPANY_PROFILE({ commit }, profileId) {
    return new Promise((resolve) => {
      commit(types.CURRENT_COMPANY_PROFILE_SELECTED, profileId);
      resolve();
    });
  },
  CREATE_COMPANY_PROFILE_INFO({ commit }, { companyId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.CREATE_COMPANY_PROFILE_INFO_REQUEST);
      company.createCompanyProfile(companyId, payload, (err, result) => {
        if (err) {
          commit(types.CREATE_COMPANY_PROFILE_INFO_FAIL);
          return reject(err);
        }
        commit(types.CREATE_COMPANY_PROFILE_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_COMPANY_PROFILE_INFO({ commit }, { profileId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_COMPANY_PROFILE_INFO_REQUEST);
      company.updateCompanyProfile(profileId, payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_COMPANY_PROFILE_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_COMPANY_PROFILE_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_COMPANY_PROFILE_INFO({ commit }, profileId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_COMPANY_PROFILE_INFO_REQUEST);
      company.deleteCompanyProfile(profileId, (err) => {
        if (err) {
          commit(types.DELETE_COMPANY_PROFILE_INFO_FAIL);
          return reject(err);
        }
        commit(types.DELETE_COMPANY_PROFILE_INFO_SUCCESS, profileId);
        return resolve();
      });
    });
  },
  // Company Admin Users
  GET_COMPANY_ADMIN_LIST({ commit }, companyId) {
    return new Promise((resolve, reject) => {
      commit(types.GET_COMPANY_ADMIN_LIST_REQUEST);
      company.getCompanyAdmin(companyId, (err, result) => {
        if (err) {
          commit(types.GET_COMPANY_ADMIN_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_COMPANY_ADMIN_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_COMPANY_ADMIN({ commit }, userId) {
    return new Promise((resolve) => {
      commit(types.CURRENT_COMPANY_ADMIN_SELECTED, userId);
      resolve();
    });
  },
  CREATE_COMPANY_ADMIN_INFO({ commit }, { companyId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.CREATE_COMPANY_ADMIN_INFO_REQUEST);
      company.createCompanyAdmin(companyId, payload, (err, result) => {
        if (err) {
          commit(types.CREATE_COMPANY_ADMIN_INFO_FAIL);
          return reject(err);
        }
        commit(types.CREATE_COMPANY_ADMIN_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_COMPANY_ADMIN_INFO({ commit }, { userId, payload }) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_COMPANY_ADMIN_INFO_REQUEST);
      company.updateCompanyAdmin(userId, payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_COMPANY_ADMIN_INFO_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_COMPANY_ADMIN_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_COMPANY_ADMIN_INFO({ commit }, userId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_COMPANY_ADMIN_INFO_REQUEST);
      company.deleteCompanyAdmin(userId, (err) => {
        if (err) {
          commit(types.DELETE_COMPANY_ADMIN_INFO_FAIL);
          return reject(err);
        }
        commit(types.DELETE_COMPANY_ADMIN_INFO_SUCCESS, userId);
        return resolve();
      });
    });
  },
  // Admin Users
  GET_ADMIN_MY_ADMIN_INFO({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.GET_ADMIN_MY_ADMIN_INFO_REQUEST);
      company.getAdminMyAdmin((err, result) => {
        if (err) {
          commit(types.GET_ADMIN_MY_ADMIN_INFO_FAIL);
          return reject(err);
        }
        commit(types.GET_ADMIN_MY_ADMIN_INFO_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  GET_ADMIN_USER_LIST({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.GET_ADMIN_USER_LIST_REQUEST);
      company.getAdminUser((err, result) => {
        if (err) {
          commit(types.GET_ADMIN_USER_LIST_FAIL);
          return reject(err);
        }
        commit(types.GET_ADMIN_USER_LIST_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  CREATE_ADMIN_USER({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.CREATE_ADMIN_USER_REQUEST);
      company.createAdminUser(payload, (err, result) => {
        if (err) {
          commit(types.CREATE_ADMIN_USER_FAIL);
          return reject(err);
        }
        commit(types.CREATE_ADMIN_USER_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  UPDATE_ADMIN_USER({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit(types.UPDATE_ADMIN_USER_REQUEST);
      company.updateAdminUser(payload, (err, result) => {
        if (err) {
          commit(types.UPDATE_ADMIN_USER_FAIL);
          return reject(err);
        }
        commit(types.UPDATE_ADMIN_USER_SUCCESS, result);
        return resolve(result);
      });
    });
  },
  DELETE_ADMIN_USER({ commit }, userId) {
    return new Promise((resolve, reject) => {
      commit(types.DELETE_ADMIN_USER_REQUEST);
      company.deleteAdminUser(userId, (err) => {
        if (err) {
          commit(types.DELETE_ADMIN_USER_FAIL);
          return reject(err);
        }
        commit(types.DELETE_ADMIN_USER_SUCCESS, userId);
        return resolve();
      });
    });
  },
  UNBLOCK_ADMIN_USER({ commit }, adminId) {
    return new Promise((resolve, reject) => {
      commit(types.UNBLOCK_ADMIN_USER_REQUEST);
      company.unblockAdminUser(adminId, (err) => {
        if (err) {
          commit(types.UNBLOCK_ADMIN_USER_FAIL);
          return reject(err);
        }
        commit(types.UNBLOCK_ADMIN_USER_SUCCESS, adminId);
        return resolve();
      });
    });
  },
};
const mutations = {
  [types.GET_COMPANY_LIST_REQUEST](state) {
    state.isGettingCompany = true;
  },
  [types.GET_COMPANY_LIST_SUCCESS](state, result) {
    state.isGettingCompany = false;
    state.companyList = result;
    // rebuild index
    rebuildCompanyIndex(state);
  },
  [types.GET_COMPANY_LIST_FAIL](state) {
    state.isGettingCompany = false;
  },
  [types.CURRENT_COMPANY_SELECTED](state, companyId) {
    state.currentCompanyId = companyId;
  },
  [types.UPLOAD_COMPANY_LOGO_REQUEST](state) {
    state.isUploadingCompanyFile = true;
  },
  [types.UPLOAD_COMPANY_LOGO_FAIL](state) {
    state.isUploadingCompanyFile = false;
  },
  [types.UPLOAD_COMPANY_LOGO_SUCCESS](state) {
    state.isUploadingCompanyFile = false;
  },
  [types.CREATE_COMPANY_INFO_REQUEST](state) {
    state.isSubmittingCompanyInfo = true;
  },
  [types.CREATE_COMPANY_INFO_FAIL](state) {
    state.isSubmittingCompanyInfo = false;
  },
  [types.CREATE_COMPANY_INFO_SUCCESS](state, result) {
    state.isSubmittingCompanyInfo = false;
    // inject data to companyList
    state.companyList.push(result);
    rebuildCompanyIndex(state);
  },
  [types.UPDATE_COMPANY_INFO_REQUEST](state) {
    state.isSubmittingCompanyInfo = true;
  },
  [types.UPDATE_COMPANY_INFO_FAIL](state) {
    state.isSubmittingCompanyInfo = false;
  },
  [types.UPDATE_COMPANY_INFO_SUCCESS](state, result) {
    state.isSubmittingCompanyInfo = false;
    // replace data in companyList
    const companyId = `_${result.id}`;
    if (typeof state.companyListIndex[companyId] !== 'undefined') {
      state.companyList.splice(state.companyListIndex[companyId], 1, result);
    }
  },
  [types.DELETE_COMPANY_INFO_REQUEST](state) {
    state.isSubmittingCompanyInfo = true;
  },
  [types.DELETE_COMPANY_INFO_FAIL](state) {
    state.isSubmittingCompanyInfo = false;
  },
  [types.DELETE_COMPANY_INFO_SUCCESS](state, companyId) {
    state.currentCompanyId = null;
    state.isSubmittingCompanyInfo = false;
    // remove data in companyList
    const idx = `_${companyId}`;
    if (typeof state.companyListIndex[idx] !== 'undefined') {
      // delete state.companyList[state.companyListIndex[idx]];
      state.companyList.splice(state.companyListIndex[idx], 1);
      rebuildCompanyIndex(state);
    }
  },
  // PROFILES
  [types.GET_COMPANY_PROFILE_LIST_REQUEST](state) {
    state.isGettingCompanyProfile = true;
  },
  [types.GET_COMPANY_PROFILE_LIST_SUCCESS](state, result) {
    state.isGettingCompanyProfile = false;
    state.companyProfileList = result;
    // rebuild index
    rebuildCompanyProfileIndex(state);
  },
  [types.GET_COMPANY_PROFILE_LIST_FAIL](state) {
    state.isGettingCompanyProfile = false;
  },
  [types.CURRENT_COMPANY_PROFILE_SELECTED](state, profileId) {
    state.currentCompanyProfileId = profileId;
  },
  [types.UPLOAD_COMPANY_PROFILE_LOGO_REQUEST](state) {
    state.isUploadingCompanyProfileFile = true;
  },
  [types.UPLOAD_COMPANY_PROFILE_LOGO_FAIL](state) {
    state.isUploadingCompanyProfileFile = false;
  },
  [types.UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS](state) {
    state.isUploadingCompanyProfileFile = false;
  },
  [types.CREATE_COMPANY_PROFILE_INFO_REQUEST](state) {
    state.isSubmittingCompanyProfileInfo = true;
  },
  [types.CREATE_COMPANY_PROFILE_INFO_FAIL](state) {
    state.isSubmittingCompanyProfileInfo = false;
  },
  [types.CREATE_COMPANY_PROFILE_INFO_SUCCESS](state, result) {
    state.isSubmittingCompanyProfileInfo = false;
    // inject data to companyList
    state.companyProfileList.push(result);
    rebuildCompanyProfileIndex(state);
  },
  [types.UPDATE_COMPANY_PROFILE_INFO_REQUEST](state) {
    state.isSubmittingCompanyProfileInfo = true;
  },
  [types.UPDATE_COMPANY_PROFILE_INFO_FAIL](state) {
    state.isSubmittingCompanyProfileInfo = false;
  },
  [types.UPDATE_COMPANY_PROFILE_INFO_SUCCESS](state, result) {
    state.isSubmittingCompanyProfileInfo = false;
    // replace data in companyList
    const profileId = `_${result.id}`;
    if (typeof state.companyProfileListIndex[profileId] !== 'undefined') {
      state.companyProfileList.splice(state.companyProfileListIndex[profileId], 1, result);
    }
  },
  [types.DELETE_COMPANY_PROFILE_INFO_REQUEST](state) {
    state.isSubmittingCompanyProfileInfo = true;
  },
  [types.DELETE_COMPANY_PROFILE_INFO_FAIL](state) {
    state.isSubmittingCompanyProfileInfo = false;
  },
  [types.DELETE_COMPANY_PROFILE_INFO_SUCCESS](state, profileId) {
    state.currentCompanyProfileId = null;
    state.isSubmittingCompanyProfileInfo = false;
    // remove data in companyList
    const idx = `_${profileId}`;
    if (typeof state.companyProfileListIndex[idx] !== 'undefined') {
      // delete state.companyProfileList[state.companyProfileListIndex[idx]];
      state.companyProfileList.splice(state.companyProfileListIndex[idx], 1);
      rebuildCompanyProfileIndex(state);
    }
  },
  // COMPANY ADMIN USERS
  [types.GET_COMPANY_ADMIN_LIST_REQUEST](state) {
    state.isGettingCompanyAdmin = true;
  },
  [types.GET_COMPANY_ADMIN_LIST_SUCCESS](state, result) {
    state.isGettingCompanyAdmin = false;
    state.companyAdminList = result;
    // rebuild index
    rebuildCompanyAdminIndex(state);
  },
  [types.GET_COMPANY_ADMIN_LIST_FAIL](state) {
    state.isGettingCompanyAdmin = false;
  },
  [types.CURRENT_COMPANY_ADMIN_SELECTED](state, userId) {
    state.currentCompanyAdminId = userId;
  },
  [types.CREATE_COMPANY_ADMIN_INFO_REQUEST](state) {
    state.isSubmittingCompanyAdminInfo = true;
  },
  [types.CREATE_COMPANY_ADMIN_INFO_FAIL](state) {
    state.isSubmittingCompanyAdminInfo = false;
  },
  [types.CREATE_COMPANY_ADMIN_INFO_SUCCESS](state, result) {
    state.isSubmittingCompanyAdminInfo = false;
    // inject data to companyAdminList
    state.companyAdminList.push(result);
    rebuildCompanyAdminIndex(state);
  },
  [types.UPDATE_COMPANY_ADMIN_INFO_REQUEST](state) {
    state.isSubmittingCompanyAdminInfo = true;
  },
  [types.UPDATE_COMPANY_ADMIN_INFO_FAIL](state) {
    state.isSubmittingCompanyAdminInfo = false;
  },
  [types.UPDATE_COMPANY_ADMIN_INFO_SUCCESS](state, result) {
    state.isSubmittingCompanyAdminInfo = false;
    // replace data in companyAdminList
    const userId = `_${result.id}`;
    if (typeof state.companyAdminListIndex[userId] !== 'undefined') {
      state.companyAdminList.splice(state.companyAdminListIndex[userId], 1, result);
    }
  },
  [types.DELETE_COMPANY_ADMIN_INFO_REQUEST](state) {
    state.isSubmittingCompanyAdminInfo = true;
  },
  [types.DELETE_COMPANY_ADMIN_INFO_FAIL](state) {
    state.isSubmittingCompanyAdminInfo = false;
  },
  [types.DELETE_COMPANY_ADMIN_INFO_SUCCESS](state, userId) {
    state.currentCompanyAdminId = null;
    state.isSubmittingCompanyAdminInfo = false;
    // remove data in companyList
    const idx = `_${userId}`;
    if (typeof state.companyAdminListIndex[idx] !== 'undefined') {
      // delete state.companyAdminList[state.companyProfileListIndex[idx]];
      state.companyAdminList.splice(state.companyProfileListIndex[idx], 1);
      rebuildCompanyAdminIndex(state);
    }
  },
  // ADMIN USERS
  [types.GET_ADMIN_USER_LIST_REQUEST](state) {
    state.isGettingAdmin = true;
  },
  [types.GET_ADMIN_USER_LIST_SUCCESS](state, result) {
    state.isGettingAdmin = false;
    state.adminList = result;
    rebuildAdminIndex(state);
  },
  [types.GET_ADMIN_USER_LIST_FAIL](state) {
    state.isGettingAdmin = false;
  },
  [types.CREATE_ADMIN_USER_REQUEST](state) {
    state.isSubmittingAdminInfo = true;
  },
  [types.CREATE_ADMIN_USER_SUCCESS](state) {
    state.isSubmittingAdminInfo = false;
    rebuildAdminIndex(state);
  },
  [types.CREATE_ADMIN_USER_FAIL](state) {
    state.isSubmittingAdminInfo = false;
  },
  [types.UPDATE_ADMIN_USER_REQUEST](state) {
    state.isSubmittingAdminInfo = true;
  },
  [types.UPDATE_ADMIN_USER_SUCCESS](state) {
    state.isSubmittingAdminInfo = false;
    // rebuildAdminIndex(state);
  },
  [types.UPDATE_ADMIN_USER_FAIL](state) {
    state.isSubmittingAdminInfo = false;
  },
  [types.DELETE_ADMIN_USER_REQUEST](state) {
    state.isSubmittingAdminInfo = true;
  },
  [types.DELETE_ADMIN_USER_SUCCESS](state) {
    state.isSubmittingAdminInfo = false;
    /* // remove data in companyList
    const idx = `_${userId}`;
    if (typeof state.companyAdminListIndex[idx] !== 'undefined') {
      // delete state.companyAdminList[state.companyProfileListIndex[idx]];
      state.adminList.splice(state.adminListIndex[idx], 1);
      rebuildAdminIndex(state);
    } */
  },
  [types.DELETE_ADMIN_USER_FAIL](state) {
    state.isSubmittingAdminInfo = false;
  },
  [types.UNBLOCK_ADMIN_USER_REQUEST](state) {
    state.isSubmittingAdminInfo = true;
  },
  [types.UNBLOCK_ADMIN_USER_SUCCESS](state) {
    state.isSubmittingAdminInfo = false;
  },
  [types.UNBLOCK_ADMIN_USER_FAIL](state) {
    state.isSubmittingAdminInfo = false;
  },
  [types.GET_ADMIN_MY_ADMIN_INFO_REQUEST](state) {
    state.isGettingAdminMyAdmin = true;
  },
  [types.GET_ADMIN_MY_ADMIN_INFO_SUCCESS](state, result) {
    state.isGettingAdminMyAdmin = false;
    state.scbAdminInfo = result;
  },
  [types.GET_ADMIN_MY_ADMIN_INFO_FAIL](state) {
    state.isGettingAdminMyAdmin = false;
  },
  [types.COMPANY_STATE_CLEARED](state) {
    state.companyList.splice(0);
    state.companyListIndex = {};
    state.isGettingCompany = false;
    state.isUploadingCompanyFile = false;
    state.isSubmittingCompanyInfo = false;
    state.currentCompanyId = null;
    state.isGettingCompanyProfile = false;
    state.companyProfileList.splice(0);
    state.companyProfileListIndex = {};
    state.isSubmittingCompanyProfileInfo = false;
    state.currentCompanyProfileId = null;
    state.isUploadingCompanyProfileFile = false;
    state.isGettingCompanyAdmin = false;
    state.companyAdminList.splice(0);
    state.companyAdminListIndex = {};
    state.isSubmittingcompanyAdminInfo = false;
    state.currentCompanyAdminId = null;
    state.isSubmittingAdminInfo = false;
    state.adminList.splice(0);
    state.adminListIndex = {};
    state.isGettingAdmin = false;
    state.companyListSearchIndex = null;
    state.adminListSearchIndex = null;
  },
};

const CompanyStore = {
  state,
  getters,
  actions,
  mutations,
};

export default CompanyStore;



// WEBPACK FOOTER //
// ./src/store/modules/company.js